//region :: Imports ::
import {ReactElement, ReactNode} from 'react';
import MComponent from '../Component';
import MErrorText from './ErrorText';
import {classNames} from 'primereact/utils';
import MHelpIcon from './HelpIcon';

//endregion

/** */
export type MFormControlBaseProps = {
    label: string;
    help?: string | ReactNode;
    icon?: string;
    expand?: boolean;
}

/** */
type Props = MFormControlBaseProps & {
    id: string;
    errorText?: string;
    children: (id: string, fieldClasses: string | undefined) => ReactNode;
}

/** */
class MFormControl extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        const icon = this.props.icon === undefined ? '' : `pi ${this.props.icon}`;
        const iconPosition = icon === '' ? '' : 'p-input-icon-right';
        const tooltipTargetName = `${this.props.id}-help`;
        const showHelpIcon = this.props.help !== undefined;

        return (

            <div className="field">

                <label htmlFor={this.props.id} className="block minput-label">
                    {this.props.label}
                </label>

                <div className="flex justify-content-start align-items-center">
                    <div className={`p-inputgroup ${iconPosition}`}>
                        <i className={icon}/>
                        {
                            this.props.children(this.props.id,
                                classNames('inputfield', {'w-full': this.props.expand ?? true}))
                        }
                    </div>
                    {
                        showHelpIcon &&
                        <span className="ml-2">
                            <MHelpIcon targetName={tooltipTargetName} tooltipContent={this.props.help!}/>
                        </span>
                    }
                </div>

                <MErrorText id={this.props.id} text={this.props.errorText}/>

            </div>
        );

    }

}

export default MFormControl;
